import template from './prime-project-view.html';
import controller from './prime-project-view.controller';

let primeProjectViewComponent = {
  restrict: 'E',
  bindings: {
    project: '<'
  },
  template,
  controller
};

export default primeProjectViewComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/prime-project-view/prime-project-view.component.js